import React from 'react';
import { Reveal } from './ui/Reveal';
import { problems } from '../data/content';
export function ProblemSection() {
  return <section aria-labelledby="problema" className="bg-white text-navy" data-id="element-126" data-mp="2ltmglpx0jlk0">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-127" data-mp="30hhd7he56a2d">
        <p className="inline-block rounded-md bg-navy px-2 py-0.5 font-sub text-sm font-semibold text-sol" data-id="element-128" data-mp="2vqhimishw431">
          ¿Te suena familiar?
        </p>
        <h2 id="problema" className="mt-2 font-display text-[1.35rem] font-extrabold uppercase leading-[1.12] tracking-tight text-navy sm:text-3xl" data-id="element-129" data-mp="39gkucftr0fe8">
          Querés viajar al exterior,{' '}
          <span className="bg-sol px-1 text-navy" data-id="element-130" data-mp="3jfadebxds5w2">
            pero te preocupa no entender inglés ni saber qué decir cuando
            alguien te haga una pregunta.
          </span>
        </h2>
        <p className="mx-auto mt-2 max-w-xl text-sm leading-snug text-navy/80" data-id="element-131" data-mp="1p2ati6lywpiz">
          Si estás preparando tus próximas vacaciones o soñás con conocer otro
          país, probablemente conozcas alguna de estas situaciones:
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-132" data-mp="obydsb08d2lk">
          {problems.map((problem, i) => <Reveal key={problem.title} as="li" delay={i * 0.03} className="h-full rounded-xl border-2 border-navy bg-cielo p-2.5 text-left" data-id="element-133" data-mp="se1qf2ymyd8f" data-mpi={i}>
              <h3 className="font-sub text-sm font-bold leading-tight text-navy" data-id="element-134" data-mp="124eayv6ga6ek">
                <span className="text-coral" aria-hidden="true" data-id="element-135" data-mp="172fvlkjiyds5">✕ </span>
                {problem.title}
              </h3>
              <p className="mt-0.5 text-xs leading-snug text-navy/80 sm:text-sm" data-id="element-136" data-mp="1c1iwqtwdvzuu">
                {problem.desc}
              </p>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}